import React, { useState, useEffect } from "react";
import {
  Snackbar,
  Box,
  Typography,
  CircularProgress,
  Tooltip,
} from "@mui/material";

const TimerToast = ({ setShowTimer, setCurrentStep, setShowQuote }) => {
  const [open, setOpen] = useState(true);
  const duration = 15 * 60;
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          setShowQuote(false);
          clearInterval(timer);
          setOpen(false);
          setCurrentStep(0);
          setShowTimer(false);
          localStorage.clear();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };

  const progressValue = (timeLeft / duration) * 100;

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Box
        sx={{
          paddingLeft: 1,
          paddingRight: 1,
          paddingBottom: 1,
          bgcolor: "primary.main",
          color: "white",
          borderRadius: 1,
          maxWidth: 400,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CircularProgress
            variant="determinate"
            value={progressValue}
            size={30}
            sx={{ color: "#000" }}
          />
          <Box>
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              Quote Session
            </Typography>
            <Typography variant="caption">
              Your Quote Expires In:
              <span style={{ color: "#000" }}> {formatTime(timeLeft)}</span>
            </Typography>
          </Box>
        </Box>
        <Typography
          fontSize={10}
          variant="caption"
          fontWeight={600}
          sx={{
            lineHeight: "1.3em",
            display: "block",
          }}
        >
          Note: Your quote, along with any selected Day/Time slot, will expire
          soon! ...and you'll need to generate a new quote to get the latest
          rates and Day/Time availability.
        </Typography>
      </Box>
    </Snackbar>
  );
};

export default TimerToast;
